import styled from 'styled-components'

export const PartnershipContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
  max-width: 1170px;

  > div {
    margin: 30px 0;
    h3,
    h5 {
      display: none;
    }
  }

  @media (max-width: 1180px) {
    padding: 0 16px;
  }

  @media (max-width: 791px) {
    > div {
      margin: 0;
    }

    button {
      font-size: 12px;
      line-height: 16px;
    }
  }
`
